import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Grow,
  Grid,
  IconButton,
  Skeleton,
  Divider,
} from '@mui/material';
import UserAvatar from '../../../common/UserAvatar';
import empty from './nocomments.jpg';
import { Close } from '@mui/icons-material';

const LikesModal = ({ open, onClose, likes, loading, isAnotherScreen, title }) => {
  const getUserPhoto = (photo) => {
    const fileName = photo ? photo.split('/').pop() : null;
    const encodedFileName = fileName ? encodeURIComponent(fileName) : null;
    const fullPhotoUrl = encodedFileName ? `${process.env.REACT_APP_BASE_PHOTO_URL}${encodedFileName}` : null;
    return fullPhotoUrl;
  };

  if (loading) {
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="likes-modal-title"
        aria-describedby="likes-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '80%', md: 400 },
            bgcolor: 'background.paper',
            border: 1,
            borderColor: 'divider',
            boxShadow: 24,
            p: { xs: 2, sm: 3, md: 4 },
            height: '50vh',
          }}
        >
          {/* Close Button */}
          <IconButton sx={{ position: 'absolute', top: 8, right: 8 }} onClick={onClose}>
            <Close sx={{ fontSize: '18px' }} />
          </IconButton>

          <Typography id="likes-modal-title" sx={{ fontSize: '18px', mb: 0.2 }}>
            {isAnotherScreen ? title : 'Likes'}
          </Typography>

          <Divider sx={{ mb: 0.2 }} />

          <List>
            {[...Array(4)].map((_, index) => (
              <ListItem key={index}>
                <ListItemAvatar>
                  <Skeleton variant="circular" width={40} height={40} />
                </ListItemAvatar>
                <ListItemText
                  primary={<Skeleton variant="text" width="90%" />}
                  secondary={<Skeleton variant="text" width="60%" />}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Modal>
    );
  }
  if (likes?.length === 0) {
    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="likes-modal-title"
        aria-describedby="likes-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '80%', md: 400 },
            bgcolor: 'background.paper',
            border: 1,
            borderColor: 'divider',
            boxShadow: 24,
            p: { xs: 2, sm: 3, md: 4 },
            height: '50vh',
          }}
        >
          {/* Close Button */}
          <IconButton sx={{ position: 'absolute', top: 8, right: 8 }} onClick={onClose}>
            <Close sx={{ fontSize: '18px' }} />
          </IconButton>

          <Typography id="likes-modal-title" sx={{ fontSize: '18px', mb: 0.2 }}>
            {isAnotherScreen ? title : 'Likes'}
          </Typography>

          <Divider sx={{ mb: 0.2 }} />

          <Grow in={true} timeout={1000}>
            <Grid
              container
              sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}
              justifyContent="center"
              alignItems="center"
            >
              <Box display="flex" flexDirection={'column'} justifyContent="center" alignItems="center" sx={{}}>
                <img style={{ width: '80%', height: '100%' }} src={empty} alt="Loading..." />
                {!isAnotherScreen ? (
                  <Typography sx={{ fontSize: '14px', p: 2, color: 'rgba(0,0,0,0.7)' }}>
                    Be the first to like
                  </Typography>
                ) : (
                  <Typography sx={{ fontSize: '14px', p: 2, color: 'rgba(0,0,0,0.7)' }}>Votes are anonymous</Typography>
                )}
              </Box>
            </Grid>
          </Grow>
        </Box>
      </Modal>
    );
  }

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="likes-modal-title" aria-describedby="likes-modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: 400 },
          bgcolor: 'background.paper',
          borderRadius: 2, // Rounded corners
          border: 1,
          borderColor: 'divider',
          boxShadow: 24, // Increased shadow for better elevation
          p: { xs: 2, sm: 3, md: 4 },
        }}
      >
        {/* Close Button */}
        <IconButton sx={{ position: 'absolute', top: 8, right: 8 }} onClick={onClose}>
          <Close sx={{ fontSize: '18px' }} />
        </IconButton>
        <Typography id="likes-modal-title" sx={{ fontSize: '18px', mb: 0.2 }}>
          {isAnotherScreen ? title : ' Likes'}
        </Typography>
        <Divider sx={{ mb: 0.2 }} /> {/* Divider for separation */}
        <List
          sx={{
            maxHeight: '50vh', // Limiting height to 50% of viewport height
            overflowY: 'auto', // Scrollbar appears if content exceeds max height
            pr: 1, // Padding for scrollbar
            '&::-webkit-scrollbar': {
              width: '0.4em',
            },
            '&::-webkit-scrollbar-track': {
              boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.1)',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              borderRadius: '10px',
            },
          }}
        >
          {likes?.map((like) => (
            <ListItem key={like?.empCode}>
              <ListItemAvatar>
                <Avatar
                  src={getUserPhoto(like?.authorUserPhoto)}
                  sx={{ img: { objectFit: 'cover', objectPosition: 'top' } }}
                />
              </ListItemAvatar>
              <ListItemText primary={isAnotherScreen ? like?.name : like?.authorName} />
            </ListItem>
          ))}
        </List>
      </Box>
    </Modal>
  );
};

export default LikesModal;
